var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 123.633,
    height: 117.334,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 117.334,
    opacity: 0,
    width: 123.633,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8164 117.334C63.0371 117.334 64.7461 116.553 65.9668 115.771C100.879 93.2617 123.633 67.2852 123.633 40.7715C123.633 18.9941 108.643 3.4668 89.0625 3.4668C77.0996 3.4668 67.334 10.2051 61.8164 20.5566C56.3477 10.2539 46.582 3.4668 34.5703 3.4668C14.9902 3.4668 0 18.9941 0 40.7715C0 67.2852 22.7539 93.2617 57.7148 115.771C58.9355 116.553 60.6445 117.334 61.8164 117.334Z",
    fill: "#ff453a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFill);
export default __webpack_public_path__ + "static/media/heart-fill.598672ea1b7a0ed9a68679ae726dddfd.svg";
export { ForwardRef as ReactComponent };